document.addEventListener('DOMContentLoaded', function () {
  const isMobile = window.innerWidth < 768; // Customize if your mobile breakpoint is different

  if (!isMobile) {
    console.log("Lazy image effect skipped for desktop");
    return; // Exit script, do nothing on desktop
  }

  const possibleSelectors = [
    '.product__media img',
    '.product-gallery img',
    '.product-main-image img',
    '.product__image img',
    '.media img',
    '.product img'
  ];

  let productImages = [];
  possibleSelectors.forEach(selector => {
    const found = document.querySelectorAll(selector);
    if (found.length > 0) {
      productImages = [...productImages, ...found];
    }
  });

  // Apply lazy class to all product images
  productImages.forEach(img => {
    img.classList.add('product-image-lazy');
  });

  // Intersection Observer for fade-in
  if ('IntersectionObserver' in window) {
    const observer = new IntersectionObserver((entries, observer) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('product-image-visible');
          observer.unobserve(entry.target);
        }
      });
    }, {
      threshold: 0.1
    });

    productImages.forEach(img => observer.observe(img));
  } else {
    // Fallback for older browsers
    productImages.forEach(img => img.classList.add('product-image-visible'));
  }

  console.log("Lazy images loaded for mobile:", productImages.length);
});
